import React from 'react';
import PropTypes from 'prop-types';
import styles from './TeamColourDot.module.css';
import { teamColourName } from 'utils/teamLabel';

// A team's colour, shown as a dot. `colour` is the stored "#RRGGBB", or
// nothing for a team with no colour, which shows as a hollow dot.
const TeamColourDot = ({ colour, large = false }) => (
  <span
    className={`${styles.dot} ${colour ? '' : styles.none} ${large ? styles.large : ''}`}
    style={colour ? { backgroundColor: colour } : undefined}
    title={colour ? teamColourName(colour) : 'No colour'}
    aria-hidden="true"
  />
);

TeamColourDot.propTypes = {
  colour: PropTypes.string,
  large: PropTypes.bool,
};

export default TeamColourDot;
